import { JobSourcingLogState } from './job-sourcing-log-selectors';
import { STARTING, SUCCESS, FAILURE } from '../action/util/action-name-creators';
import {
  Action,
  updateResourceByParam,
  setStateDirtyByParam,
  setStatusByParam,
  StateStatus,
} from '../reducers/utils/state-manager';

import { convertArrayToMap } from '../util/convert-array-to-map';

const InitialState = {
  jobSourcingLogsById: {},
  jobSourcingLogsStateByJobId: {},
  jobSourcingLogsStateByOrgId: {},
};

export const jobSourcingLogReducer = (
  state: JobSourcingLogState = InitialState,
  action: Action,
) => {
  switch (action.type) {
    case STARTING('LOAD_JOB_SOURCING_LOGS'): {
      const { jobId, orgId } = action.payload.args;
      const newState = updateResourceByParam(state, 'jobSourcingLogs', 'orgId', orgId, true);
      return jobId
        ? updateResourceByParam(newState, 'jobSourcingLogs', 'jobId', jobId, true)
        : newState;
    }
    case SUCCESS('LOAD_JOB_SOURCING_LOGS'): {
      const {
        args: { jobId, orgId },
        data,
      } = action.payload;
      const newState = updateResourceByParam(
        state,
        'jobSourcingLogs',
        'orgId',
        orgId,
        false,
        convertArrayToMap(data, (d: JobSourcingLog) => String(d.changeId)),
      );
      return jobId
        ? setStatusByParam(newState, 'jobSourcingLogs', 'jobId', jobId, StateStatus.success)
        : newState;
    }
    case FAILURE('LOAD_JOB_SOURCING_LOGS'): {
      const { jobId, orgId } = action.payload.args;
      const newState = updateResourceByParam(state, 'jobSourcingLogs', 'orgId', orgId, false);
      return jobId
        ? updateResourceByParam(newState, 'jobSourcingLogs', 'jobId', jobId, false)
        : newState;
    }
    case SUCCESS('UPDATE_JOB_STATUS'):
    case SUCCESS('UPDATE_JOB_MONTHLY_CREDIT_DOLLARS'):
    case SUCCESS('UPDATE_JOB_IS_DETERMINING_FACEBOOK_CPA'): {
      const { jobId, orgId } = action.payload.args;
      const newState = setStateDirtyByParam(state, 'jobSourcingLogs', 'orgId', orgId);
      return setStateDirtyByParam(newState, 'jobSourcingLogs', 'jobId', jobId);
    }
    case 'SAVE_AD_SPEND_SUCCESS': {
      const { jobAdSpend, orgId }: { jobAdSpend: Array<JobAdSpend>; orgId: number } =
        action.payload;
      let newState = { ...state };
      jobAdSpend.forEach((jobSpend) => {
        newState = setStateDirtyByParam(
          newState,
          'jobSourcingLogs',
          'jobId',
          String(jobSpend.jobId),
        );
      });
      return setStateDirtyByParam(newState, 'jobSourcingLogs', 'orgId', orgId.toString());
    }
    default: {
      return state;
    }
  }
};
